<template>
  <div v-if="scorecard">
    <div ref="matchSection" class="matchSection">
      <div
        v-if="(stats?.currentOver || stats?.lastOver) && scrollLeftVisible"
        class="first-card-section"
      >
        <div class="match-info-section">
          <div class="over-info-card">
            <div class="over-section">
              <div
                v-if="stats?.currentOver?.batsNames"
                class="bowler-info-section"
              >
                <span v-if="stats?.currentOver?.bowlerName" class="bowler-name">
                  {{ stats?.currentOver?.bowlerName }} to
                  {{ stats?.currentOver?.batsNames[0] }} and
                  {{ stats?.currentOver?.batsNames[1] }}
                </span>
              </div>
              <div class="over-detail">
                <div v-for="item in stats?.currentOver?.balls">
                  <div class="over-runs">
                    <span
                      class="run circle"
                      :class="{
                        four: item?.value == '4',
                        six: item?.value == '6',
                        zero: item?.value == '0',
                        wicket: item?.value === 'W'
                      }"
                      >{{ splitNos(item?.value) }}</span
                    >
                    <span class="text-ball">{{ splitWords(item?.value) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="over-target">
              <div class="over-info">
                <span v-if="stats?.currentOver"
                  >{{ 'Ov' }} {{ stats?.currentOver?.overNumber }}</span
                >
                <span v-if="!stats?.currentOver">{{ 'Ov' }} 0</span>
              </div>
              <div class="over-info">
                <span v-if="stats?.currentOver"
                  >{{ stats?.currentOver?.runs }} {{ 'runs' }}</span
                >
                <span v-if="!stats?.currentOver">0 {{ 'runs' }}</span>
              </div>
              <div class="target-info">
                <span v-if="stats?.currentOver"
                  >{{ stats?.currentOver?.score }}-{{
                    stats?.currentOver?.wickets
                  }}</span
                >
                <span v-if="!stats?.currentOver">0-0</span>
              </div>
              <div class="target-info">
                <span v-if="stats?.currentOver">{{ 'Current Over' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="stats?.lastOver" class="match-info-section">
          <div class="over-info-card">
            <div class="over-section">
              <div
                v-if="stats?.lastOver?.batsNames"
                class="bowler-info-section"
              >
                <span v-if="stats?.lastOver?.bowlerName" class="bowler-name">
                  {{ stats?.lastOver?.bowlerName }} to
                  {{ stats?.lastOver?.batsNames[0] }} and
                  {{ stats?.lastOver?.batsNames[1] }}
                </span>
              </div>
              <div class="over-detail">
                <div v-for="item in stats?.lastOver?.balls">
                  <div class="over-runs">
                    <span
                      class="run circle"
                      :class="{
                        four: item?.value == '4',
                        six: item?.value == '6',
                        zero: item?.value == '0',
                        wicket: item?.value === 'W'
                      }"
                      >{{ splitNos(item?.value) }}</span
                    >
                    <span class="text-ball">{{ splitWords(item?.value) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="over-target">
              <div class="over-info">
                <span v-if="stats?.lastOver"
                  >{{ 'Ov' }} {{ stats?.lastOver?.overNumber }}</span
                >
                <span v-if="!stats?.lastOver">{{ 'Ov' }} 0</span>
              </div>
              <div class="over-info">
                <span v-if="stats?.lastOver"
                  >{{ stats?.lastOver?.runs }} {{ 'runs' }}</span
                >
                <span v-if="!stats?.lastOver">0 {{ 'runs' }}</span>
              </div>
              <div class="target-info">
                <span v-if="stats?.lastOver"
                  >{{ stats?.lastOver?.score }}-{{
                    stats?.lastOver?.wickets
                  }}</span
                >
                <span v-if="!stats?.lastOver">0-0</span>
              </div>
              <div class="target-info">
                <span v-if="stats?.lastOver">{{ 'Last Over' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Match Info Second section-->
      <div v-if="scrollRightVisible" class="match-info-second-section">
        <div class="match-info-second-card">
          <div class="first-card">
            <div class="first-box">
              <small class="ellip">{{ 'PROJ SCR' }}</small>
              <span v-if="stats?.battingTeam?.projScr" class="ellip">{{
                stats?.battingTeam?.projScr
              }}</span>
              <span v-if="!stats?.battingTeam?.projScr">-</span>
            </div>
            <div class="second-box">
              <small class="ellip">{{ "P'SHIP" }}</small>
              <span v-if="stats?.battingTeam?.partnerShipScore" class="ellip"
                >{{ stats?.battingTeam?.partnerShipScore }}({{
                  stats?.battingTeam?.partnerShipBalls
                }})</span
              >
              <span v-if="!stats?.battingTeam?.partnerShipScore">-</span>
            </div>
            <div class="third-box">
              <small>{{ 'CRR' }}</small>
              <span class="ellip">{{
                stats?.battingTeam?.runRate || '-'
              }}</span>
            </div>
            <div class="fourth-box">
              <small class="ellip">{{ 'LAST WKT' }}</small>
              <span v-if="stats?.lastBatsmanOut" class="ellip"
                >{{ stats?.lastBatsmanOut?.name }}
                {{ stats?.lastBatsmanOut?.batsManRuns }}({{
                  stats?.lastBatsmanOut?.balls
                }})</span
              >
              <span v-if="!stats?.lastBatsmanOut" class="ellip">-</span>
            </div>
          </div>
          <table class="scoreBoard-card">
            <thead>
              <tr>
                <th class="main-head">{{ 'BATSMAN' }}</th>
                <th class="runs">{{ 'R' }}</th>
                <th class="balls">{{ 'B' }}</th>
                <th class="fours">{{ '4s' }}</th>
                <th class="sixes">{{ '6s' }}</th>
                <th class="sr">{{ 'SR' }}</th>
              </tr>
            </thead>
            <tbody>
              <div v-for="item in stats?.batsmen">
                <tr>
                  <td class="main-head">
                    {{ item?.name }}<sup v-if="item?.isOnStrike"> *</sup>
                  </td>
                  <td class="runs">{{ item?.batsmanRuns || '-' }}</td>
                  <td class="balls">{{ item?.balls || '-' }}</td>
                  <td class="fours">{{ item?.fours || '-' }}</td>
                  <td class="sixes">{{ item?.sixes || '-' }}</td>
                  <td class="sr">
                    {{
                      item?.strikeRate !== undefined
                        ? item?.strikeRate?.toFixed(2)
                        : '-'
                    }}
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
          <table class="scoreBoard-card-1">
            <thead>
              <tr>
                <th class="main-head">{{ 'Bowler' }}</th>
                <th class="runs">{{ 'O' }}</th>
                <th class="balls">{{ 'M' }}</th>
                <th class="fours">{{ 'R' }}</th>
                <th class="sixes">{{ 'W' }}</th>
                <th class="sr">{{ 'ECO' }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="stats?.bowler">
                <td class="main-head">{{ stats?.bowler?.name }}</td>
                <td class="runs">{{ stats?.bowler?.overs }}</td>
                <td class="balls">{{ stats?.bowler?.maidens }}</td>
                <td class="fours">{{ stats?.bowler?.bowlerRuns }}</td>
                <td class="sixes">{{ stats?.bowler?.wickets }}</td>
                <td class="sr">{{ stats?.bowler?.economy?.toFixed(2) }}</td>
              </tr>
              <tr v-if="stats?.bowler?.length === 0">
                <td class="main-head">-</td>
                <td class="runs">-</td>
                <td class="balls">-</td>
                <td class="fours">-</td>
                <td class="sixes">-</td>
                <td class="sr">-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      v-if="stats?.currentOver || stats?.lastOver"
      class="change-score-section"
    >
      <span
        class="inactive"
        :class="{ active: scrollLeftVisible }"
        @click="scrollLeft()"
      ></span>
      <span
        class="inactive"
        :class="{ active: scrollRightVisible }"
        @click="scrollRight()"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    stats: {
      type: Object,
      default: () => {},
      required: true
    },
    scorecard: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      scrollLeftVisible: true,
      scrollRightVisible: false
    }
  },
  methods: {
    scrollLeft() {
      this.$refs.matchSection.scrollLeft = 0
      this.scrollRightVisible = false
      this.scrollLeftVisible = true
    },
    scrollRight() {
      this.$refs.matchSection.scrollLeft = this.$refs.matchSection.scrollWidth
      this.scrollLeftVisible = false
      this.scrollRightVisible = true
    },
    splitWords(str) {
      if (str === 'W') {
        return null
      } else {
        const words = str.match(/[a-zA-Z]+/g)
        return words
      }
    },
    splitNos(str) {
      let nos
      if (!str) return
      if (str !== 'W') {
        if (str === 'wd' || str === 'nb') {
          str === 'wd' ? (str = '1wd') : (str = '1nb')
          nos = str?.match(/\d+/g)?.[0]
        } else {
          nos = str?.match(/\d+/g)?.[0]
        }
        return nos
      } else {
        return str
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.matchSection {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: none !important;
  padding-bottom: 2%;

  &::-webkit-scrollbar {
    height: 0px !important;
    width: 0px !important;
    display: none;
  }
}

.first-card-section {
  margin-top: 8px;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 0px 12px;
  min-height: 226px;
  //animation: scrollFromRight 0.5s ease-in-out forwards;
}

.match-info-section {
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  animation: openPopup 0.5s ease-in-out forwards;
}
.over-section > span > span {
  color: #f0f2f4;
  font-family: 'Lato', sans-serif !important;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.match-info-second-section {
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 0px 12px;
  min-height: 226px;
  animation: scrollFromRight 0.5s ease-in-out forwards;

  .match-info-second-card {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    border-radius: 12px;
    border: 1px solid #eb6e25;
    background: linear-gradient(91deg, #1e1e1e 3.8%, #2f2f30 105.21%);
    height: 100%;

    .first-card {
      display: flex;
      padding: 12px 12px 10px 12px;
      align-items: flex-start;
      gap: 12px;
      align-self: stretch;
      border-bottom: 1px solid #164d75;
      justify-content: flex-start;
      height: fit-content;

      .first-box {
        display: flex;
        padding-right: 0px;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        border-right: 1px solid #164d75;
        padding-right: 12px;
        height: 100%;
      }

      small {
        color: #929eb5;
        font-family: 'Lato', sans-serif !important;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
      }

      .second-box {
        display: flex;
        padding-right: 0px;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        border-right: 1px solid #164d75;
        padding-right: 12px;
        height: 100%;
      }

      .third-box {
        display: flex;
        padding-right: 0px;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        border-right: 1px solid #164d75;
        padding-right: 12px;
        height: 100%;
      }

      .fourth-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        height: 100%;
      }
    }
  }
}
span.ellip {
  color: #f0f2f4;
  font-family: 'Lato', sans-serif !important;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  //   white-space: pre-wrap;
}
.over-info > span,
.target-info > span {
  color: #f0f2f4;
  font-family: 'Lato', sans-serif !important;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  white-space: pre-wrap;
}

.scoreBoard-card {
  display: flex;
  flex-direction: column;
  padding: 0px 12px 12px 12px;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid #164d75;

  thead {
    width: 100%;

    > tr {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .main-head {
        width: 36%;
        color: #929eb5;
        font-family: 'Lato', sans-serif !important;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        padding-bottom: 4px;
        display: flex;
        flex-wrap: wrap;
      }

      > th {
        color: #929eb5;
        font-family: 'Lato', sans-serif !important;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        padding-bottom: 4px;
      }
    }
  }

  tbody {
    width: 100%;

    tr {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .main-head {
        width: 36%;
        color: #f0f2f4;
        font-family: 'Lato', sans-serif !important;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        display: flex;
        flex-wrap: wrap;
        /* 19.5px */
      }

      td {
        color: #f0f2f4;
        font-family: 'Lato', sans-serif !important;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 19.5px */
      }
    }
  }
}

.scoreBoard-card-1 {
  display: flex;
  flex-direction: column;
  padding: 0px 12px 12px 12px;
  align-items: flex-start;
  align-self: stretch;

  thead {
    width: 100%;

    tr {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .main-head {
        width: 36%;
        color: #929eb5;
        font-family: 'Lato', sans-serif !important;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        padding-bottom: 4px;
      }

      th {
        color: #929eb5;
        font-family: 'Lato', sans-serif !important;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        padding-bottom: 4px;
      }
    }
  }

  tbody {
    width: 100%;

    tr {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .main-head {
        width: 36%;
        color: #f0f2f4;
        font-family: 'Lato', sans-serif !important;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 19.5px */
      }

      td {
        color: #f0f2f4;
        font-family: 'Lato', sans-serif !important;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 19.5px */
      }
    }
  }
}

.change-score-section {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}
.change-score-section > .inactive {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #42567e;
}
.change-score-section > .active {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
}

.runs {
  max-width: 12%;
  min-width: 10%;
}

.balls {
  max-width: 12%;
  min-width: 10%;
}

.fours {
  width: 7%;
}

.sixes {
  width: 7%;
}

.sr {
  width: 12%;
}

.SRWidgetContainer {
  padding-top: 7px;
}

.over-runs {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
}
.text-ball {
  color: #929eb5 !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 10px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 120% !important;
  text-transform: capitalize;
  margin-top: 10%;
}

@media screen and (min-width: 600px) {
  .matchSection {
    display: flex;
    flex-direction: column;
  }

  .first-card-section {
    flex-direction: row;
    min-height: max-content;
    gap: 2%;
  }
  .match-info-section {
    min-width: 49%;
    max-width: 49%;
  }

  .change-score-section {
    display: none;
  }

  .match-info-second-section {
    min-height: max-content;
  }
}

@keyframes openPopup {
  0% {
    opacity: 0.7;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes scrollFromRight {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.over-detail {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;

  .nb {
    display: flex;
    align-items: center;
    gap: 3px;
    flex-direction: row;
    margin: 0 8px;
  }

  .wd {
    border-radius: 50%;
    background: var(
      --gradient-gradient-9,
      linear-gradient(92deg, #efc01b 0%, #fb923c 99.71%)
    );
  }

  .four {
    border-radius: 50%;
    background: linear-gradient(93deg, #9191f5 10.51%, #63abd6 89.68%);
  }

  .six {
    border-radius: 50%;
    background: linear-gradient(267deg, #f344ab 1.67%, #9d1063 106.43%);
  }

  .zero {
    border-radius: 50%;
    background: var(--background-default-1300, #617293);
  }

  .wicket {
    border-radius: 50%;
    background: var(
      --gradient-gradient-9,
      linear-gradient(92deg, #efc01b 0%, #fb923c 99.71%)
    );
  }
}
.over-section {
  display: flex;
  width: 300px;
  height: max-content;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  padding: 12px 12px 12px 12px;
  width: 100%;
  white-space: normal;
}

.over-section > .bowler-info-section > .bowler-name {
  color: #f0f2f4;
  font-family: 'Lato', sans-serif !important;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
}

.circle {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

// small {
//   color: var(--background-default-1200, #929eb5);
//   font-family: 'Lato', sans-serif !important;
//   font-size: 10px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 120%;
// }

.run {
  border-radius: 20px;
  background: var(
    --gradient-green-gredient,
    linear-gradient(92deg, #48cd83 1.85%, #0c8d47 100%)
  );
}
.match-info-section > .over-info-card {
  width: 100%;
  min-height: 109px;
  max-height: max-content;
  border-radius: 12px;
  border: 1px solid #fafafa;
  //   background: linear-gradient(91deg, #153358 3.8%, #071d3f 105.21%);
  background: linear-gradient(91deg, #272727 3.8%, #1e1e1e 105.21%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.over-info-card > .over-target {
  display: flex;
  width: 100%;
  height: max-content;
  padding: 0px 13px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 0px 0px 12px 12px;
  background: rgb(236 110 37);
}
.over-target > .over-info {
  display: flex;
  padding: 4px 12px 4px 0px;
  align-items: center;
  gap: 10px;
  border-right: 1px solid rgba(66, 86, 126, 0.5);
}

.over-target > .target-info {
  display: flex;
  padding: 4px 12px 4px 0px;
  align-items: center;
  gap: 10px;
}
</style>
